import { inject, Pipe, PipeTransform, TemplateRef } from '@angular/core';
import { SliderButtonViewComponent } from '../../pages/home/components/views/slider/slider-button-view/slider-button-view.component';
import { SliderSquaretextViewComponent } from '../../pages/home/components/views/slider/slider-squaretext-view/slider-squaretext-view.component';
import { SliderMultisquareViewComponent } from '../../pages/home/components/views/slider/slider-multisquare-view/slider-multisquare-view.component';
import { SliderMulticityViewComponent } from '../../pages/home/components/views/slider/slider-multicity-view/slider-multicity-view.component';
import { SliderSlidemenuViewComponent } from '../../pages/home/components/views/slider/slider-slidemenu-view/slider-slidemenu-view.component';
import { PrimaryBannerComponent } from '../../pages/home/components/views/banner/main/primary-banner/primary-banner.component';
import { SlideBannerComponent } from '../../pages/home/components/views/banner/main/slide-banner/slide-banner.component';
import { SingleBannerComponent } from '../../pages/home/components/views/banner/single/single-banner.component';
import { SliderMultisquareViewMshComponent } from '../../pages/home/components/views/slider/slider-multisquare-view-msh/slider-multisquare-view-msh.component';
import { Router } from '@angular/router';

export const homepageFlexTemplates: any = {
  'square_text': SliderSquaretextViewComponent,
  'multi_square': SliderMultisquareViewComponent,
  'multi_square_msh': SliderMultisquareViewMshComponent,
  'multi_city': SliderMulticityViewComponent,
  'slide_menu': SliderSlidemenuViewComponent,
  'button': SliderButtonViewComponent,
  'primery_banner': PrimaryBannerComponent,
  'slide_banner': SlideBannerComponent,
  'single_banner': SingleBannerComponent,
};

@Pipe({
  name: 'getFlexSection',
})
export class GetFlexSectionPipe implements PipeTransform {
   router = inject(Router);
   transform(sectionName?: string): any {
    if (this.router.url.split('/')[1] == 'villa-mashhad' && sectionName == 'multi_square') {
      sectionName = 'multi_square_msh';
    }
    return homepageFlexTemplates[sectionName!];
  }
}
